/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * The client-facing name for a bookable modality — bijective with the visit ``Feature``\ s
 * (see ``feature``).
 *
 * Reuses the FE's own selection ids (``payment_visit_type``), so an API response round-trips
 * back into the metadata the FE posts at checkout.
 */
export type VisitType = (typeof VisitType)[keyof typeof VisitType];

export const VisitType = {
  live_chat: "live_chat",
  live_video: "live_video",
  async_rx: "async_rx",
  async_dx: "async_dx",
  rx_renewal: "rx_renewal",
  follow_up: "follow_up",
} as const;
